import 'reflect-metadata';
import { asEntity, Convertible } from '../Commons';
import { FundEntity } from './Fund.Entity';
import { BaseEntity } from './index.exports';

@asEntity()
export class HistoryDelegation extends BaseEntity {
    protected static _apiRoute: string = 'history-delegations';
    protected static _className: string = 'History Delegation';

    // #region fields

    @Convertible({ type: String, propertyToFill: 'fund', relation: 'ManyToOne', typeRelation: FundEntity, cascadeSave: true, cascadeLoad: false })
    fund_id!: string;
    fund!: FundEntity | undefined;

    @Convertible({})
    date!: Date;

    @Convertible({})
    newDelegations!: bigint;

    @Convertible({})
    totalDelegations!: bigint;

    @Convertible({ isCreatedAt: true })
    createdAt!: Date;

    @Convertible({ isUpdatedAt: true })
    updatedAt!: Date;

    // #endregion fields

    // #region  db

    public static defaultFieldsWhenUndefined: Record<string, boolean> = {};

    public static alwaysFieldsForSelect: Record<string, boolean> = {
        ...super.alwaysFieldsForSelect,
        fund_id: true,
        date: true,
        newDelegations: true,
        totalDelegations: true,
    };

    // #endregion  db

    // #region class methods

    public show(): string {
        return `[${this.date} - ${this.fund_id}] delegations: ${this.newDelegations} - totalDelegations: ${this.totalDelegations}}`;
    }

    // #endregion class methods
}
